import { BaseContainerModel } from '../base-container.model';

import {
  bl_pgw_contract_rate_event_RowClass,
  bl_pgw_contract_rate_event_RowInterface
} from '../../dbschema';

export class PGWContractRateEventContainerModel extends BaseContainerModel {
  bl_pgw_contract_rate_event: bl_pgw_contract_rate_event_RowInterface = new bl_pgw_contract_rate_event_RowClass();
}
